import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm._.isEmpty(_vm.sessionObject) || !_vm._.isEmpty(_vm.shareToken))?_c(VContainer,{staticClass:"loading-container"},[_c(VRow,{staticClass:"fill-height",attrs:{"align":"center","justify":"center"}},[_c(VProgressCircular,{attrs:{"size":50,"color":"#1C1836","indeterminate":""}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }